// VoiceSpectrum.Web.T2 · v12.10.9.1 (#1287) · 2026-10-06
// The page after sign-in. v12.10.9.1 (#1287): decided by the person's USER GROUPS (GET /api/t2/security/me), not by the
// old token role / "permissions" claim - a Front desk person is a plain tenant_user with no such claim and landed on
// "Access not configured" (Tushar 10/6, Jessica Parker). Order: Messages (phone calls or texts) -> Contacts -> Settings.
// "Access not configured" only when the groups give nothing at all.
import { Navigate } from 'react-router-dom';
import { useAccess } from '../lib/useAccess';

export default function TenantHomeRedirect() {
  const { me, ready, failed, canOpen } = useAccess();

  if (!ready) return null;
  // Older API without /me: keep the old behaviour of opening Messages (the server still refuses what is not allowed).
  if (failed || !me) return <Navigate to="/messages" replace />;

  if (canOpen('phone') || canOpen('texts')) return <Navigate to="/messages" replace />;
  if (canOpen('contacts')) return <Navigate to="/contacts" replace />;
  const anySetting = Object.keys(me.access ?? {}).some((k) => (k.startsWith('s:') || k.startsWith('sec_')) && (me.access[k] ?? []).length > 0);
  if (anySetting) return <Navigate to="/settings" replace />;

  return (
    <div className="tenant-page">
      <section className="tenant-empty">
        <h1>No access yet</h1>
        <p>Your account is active, but your groups don’t give you any screens yet. Ask an administrator in your practice to add you to a group.</p>
      </section>
    </div>
  );
}
